 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLFM01 from '@/components/xhtml/fm01'
 import XHTMLHALFTITLE from '@/components/xhtml/halftitle'
 import XHTMLFM02 from '@/components/xhtml/fm02'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLDEDIC from '@/components/xhtml/dedic'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLPREFACE from '@/components/xhtml/preface'
 import XHTMLACK from '@/components/xhtml/ack'
 import XHTMLHALFTITLE1 from '@/components/xhtml/halftitle1'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLBIBLIO from '@/components/xhtml/biblio'
 import XHTMLILLUST from '@/components/xhtml/illust'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLPAGE_3 from '@/components/xhtml/page_3'
 import XHTMLPAGE_4 from '@/components/xhtml/page_4'
 import XHTMLPAGE_5 from '@/components/xhtml/page_5'
 import XHTMLPAGE_6 from '@/components/xhtml/page_6'
 import XHTMLPAGE_7 from '@/components/xhtml/page_7'
 import XHTMLPAGE_9 from '@/components/xhtml/page_9'
 import XHTMLPAGE_10 from '@/components/xhtml/page_10'
 import XHTMLPAGE_13 from '@/components/xhtml/page_13'
 import XHTMLPAGE_14 from '@/components/xhtml/page_14'
 import XHTMLPAGE_15 from '@/components/xhtml/page_15'
 import XHTMLPAGE_17 from '@/components/xhtml/page_17'
 import XHTMLPAGE_18 from '@/components/xhtml/page_18'
 import XHTMLPAGE_19 from '@/components/xhtml/page_19'
 import XHTMLPAGE_20 from '@/components/xhtml/page_20'
 import XHTMLPAGE_21 from '@/components/xhtml/page_21'
 import XHTMLPAGE_22 from '@/components/xhtml/page_22'
 import XHTMLPAGE_23 from '@/components/xhtml/page_23'
 import XHTMLPAGE_24 from '@/components/xhtml/page_24'
 import XHTMLPAGE_25 from '@/components/xhtml/page_25'
 import XHTMLPAGE_26 from '@/components/xhtml/page_26'
 import XHTMLPAGE_27 from '@/components/xhtml/page_27'
 import XHTMLPAGE_29 from '@/components/xhtml/page_29'
 import XHTMLPAGE_30 from '@/components/xhtml/page_30'
 import XHTMLPAGE_31 from '@/components/xhtml/page_31'
 import XHTMLPAGE_32 from '@/components/xhtml/page_32'
 import XHTMLPAGE_33 from '@/components/xhtml/page_33'
 import XHTMLPAGE_34 from '@/components/xhtml/page_34'
 import XHTMLPAGE_35 from '@/components/xhtml/page_35'
 import XHTMLPAGE_40 from '@/components/xhtml/page_40'
 import XHTMLPAGE_41 from '@/components/xhtml/page_41'
 import XHTMLPAGE_42 from '@/components/xhtml/page_42'
 import XHTMLPAGE_43 from '@/components/xhtml/page_43'
 import XHTMLPAGE_44 from '@/components/xhtml/page_44'
 import XHTMLPAGE_45 from '@/components/xhtml/page_45'
 import XHTMLPAGE_50 from '@/components/xhtml/page_50'
 import XHTMLPAGE_53 from '@/components/xhtml/page_53'
 import XHTMLPAGE_54 from '@/components/xhtml/page_54'
 import XHTMLPAGE_55 from '@/components/xhtml/page_55'
 import XHTMLPAGE_56 from '@/components/xhtml/page_56'
 import XHTMLPAGE_57 from '@/components/xhtml/page_57'
 import XHTMLPAGE_58 from '@/components/xhtml/page_58'
 import XHTMLPAGE_59 from '@/components/xhtml/page_59'
 import XHTMLPAGE_60 from '@/components/xhtml/page_60'
 import XHTMLPAGE_61 from '@/components/xhtml/page_61'
 import XHTMLPAGE_62 from '@/components/xhtml/page_62'
 import XHTMLPAGE_63 from '@/components/xhtml/page_63'
 import XHTMLPAGE_65 from '@/components/xhtml/page_65'
 import XHTMLPAGE_66 from '@/components/xhtml/page_66'
 import XHTMLPAGE_67 from '@/components/xhtml/page_67'
 import XHTMLPAGE_68 from '@/components/xhtml/page_68'
 import XHTMLPAGE_69 from '@/components/xhtml/page_69'
 import XHTMLPAGE_70 from '@/components/xhtml/page_70'
 import XHTMLPAGE_71 from '@/components/xhtml/page_71'
 import XHTMLPAGE_72 from '@/components/xhtml/page_72'
 import XHTMLPAGE_74 from '@/components/xhtml/page_74'
 import XHTMLPAGE_75 from '@/components/xhtml/page_75'
 import XHTMLPAGE_78 from '@/components/xhtml/page_78'
 import XHTMLPAGE_79 from '@/components/xhtml/page_79'
 import XHTMLPAGE_80 from '@/components/xhtml/page_80'
 import XHTMLPAGE_81 from '@/components/xhtml/page_81'
 import XHTMLPAGE_83 from '@/components/xhtml/page_83'
 import XHTMLPAGE_84 from '@/components/xhtml/page_84'
 import XHTMLPAGE_86 from '@/components/xhtml/page_86'
 import XHTMLPAGE_87 from '@/components/xhtml/page_87'
 import XHTMLPAGE_88 from '@/components/xhtml/page_88'
 import XHTMLPAGE_89 from '@/components/xhtml/page_89'
 import XHTMLPAGE_91 from '@/components/xhtml/page_91'
 import XHTMLPAGE_92 from '@/components/xhtml/page_92'
 import XHTMLPAGE_93 from '@/components/xhtml/page_93'
 import XHTMLPAGE_94 from '@/components/xhtml/page_94'
 import XHTMLPAGE_95 from '@/components/xhtml/page_95'
 import XHTMLPAGE_96 from '@/components/xhtml/page_96'
 import XHTMLPAGE_97 from '@/components/xhtml/page_97'
 import XHTMLPAGE_98 from '@/components/xhtml/page_98'
 import XHTMLPAGE_100 from '@/components/xhtml/page_100'
 import XHTMLPAGE_103 from '@/components/xhtml/page_103'
 import XHTMLPAGE_104 from '@/components/xhtml/page_104'
 import XHTMLPAGE_107 from '@/components/xhtml/page_107'
 import XHTMLPAGE_108 from '@/components/xhtml/page_108'
 import XHTMLPAGE_110 from '@/components/xhtml/page_110'
 import XHTMLPAGE_111 from '@/components/xhtml/page_111'
 import XHTMLPAGE_112 from '@/components/xhtml/page_112'
 import XHTMLPAGE_113 from '@/components/xhtml/page_113'
 import XHTMLPAGE_114 from '@/components/xhtml/page_114'
 import XHTMLPAGE_117 from '@/components/xhtml/page_117'
 import XHTMLPAGE_118 from '@/components/xhtml/page_118'
 import XHTMLPAGE_119 from '@/components/xhtml/page_119'
 import XHTMLPAGE_120 from '@/components/xhtml/page_120'
 import XHTMLPAGE_121 from '@/components/xhtml/page_121'
 import XHTMLPAGE_122 from '@/components/xhtml/page_122'
 import XHTMLPAGE_123 from '@/components/xhtml/page_123'
 import XHTMLPAGE_124 from '@/components/xhtml/page_124'
 import XHTMLPAGE_125 from '@/components/xhtml/page_125'
 import XHTMLPAGE_126 from '@/components/xhtml/page_126'
 import XHTMLPAGE_128 from '@/components/xhtml/page_128'
 import XHTMLPAGE_129 from '@/components/xhtml/page_129'
 import XHTMLPAGE_132 from '@/components/xhtml/page_132'
 import XHTMLPAGE_133 from '@/components/xhtml/page_133'
 import XHTMLPAGE_134 from '@/components/xhtml/page_134'
 import XHTMLPAGE_135 from '@/components/xhtml/page_135'
 import XHTMLPAGE_138 from '@/components/xhtml/page_138'
 import XHTMLPAGE_139 from '@/components/xhtml/page_139'
 import XHTMLPAGE_140 from '@/components/xhtml/page_140'
 import XHTMLPAGE_141 from '@/components/xhtml/page_141'
 import XHTMLPAGE_142 from '@/components/xhtml/page_142'
 import XHTMLPAGE_143 from '@/components/xhtml/page_143'
 import XHTMLPAGE_144 from '@/components/xhtml/page_144'
 import XHTMLPAGE_145 from '@/components/xhtml/page_145'
 import XHTMLPAGE_151 from '@/components/xhtml/page_151'
 import XHTMLPAGE_153 from '@/components/xhtml/page_153'
 import XHTMLPAGE_155 from '@/components/xhtml/page_155'
 import XHTMLPAGE_156 from '@/components/xhtml/page_156'
 import XHTMLPAGE_157 from '@/components/xhtml/page_157'
 import XHTMLPAGE_158 from '@/components/xhtml/page_158'
 import XHTMLPAGE_159 from '@/components/xhtml/page_159'
 import XHTMLPAGE_160 from '@/components/xhtml/page_160'
 import XHTMLPAGE_161 from '@/components/xhtml/page_161'
 import XHTMLPAGE_163 from '@/components/xhtml/page_163'
 import XHTMLPAGE_164 from '@/components/xhtml/page_164'
 import XHTMLPAGE_165 from '@/components/xhtml/page_165'
 import XHTMLPAGE_167 from '@/components/xhtml/page_167'
 import XHTMLPAGE_168 from '@/components/xhtml/page_168'
 import XHTMLPAGE_169 from '@/components/xhtml/page_169'
 import XHTMLPAGE_170 from '@/components/xhtml/page_170'
 import XHTMLPAGE_172 from '@/components/xhtml/page_172'
 import XHTMLPAGE_173 from '@/components/xhtml/page_173'
 import XHTMLPAGE_174 from '@/components/xhtml/page_174'
 import XHTMLPAGE_175 from '@/components/xhtml/page_175'
 import XHTMLPAGE_177 from '@/components/xhtml/page_177'
 import XHTMLPAGE_178 from '@/components/xhtml/page_178'
 import XHTMLPAGE_180 from '@/components/xhtml/page_180'
 import XHTMLPAGE_181 from '@/components/xhtml/page_181'
 import XHTMLPAGE_183 from '@/components/xhtml/page_183'
 import XHTMLPAGE_184 from '@/components/xhtml/page_184'
 import XHTMLPAGE_185 from '@/components/xhtml/page_185'
 import XHTMLPAGE_186 from '@/components/xhtml/page_186'
 import XHTMLPAGE_189 from '@/components/xhtml/page_189'
 import XHTMLPAGE_190 from '@/components/xhtml/page_190'
 import XHTMLPAGE_191 from '@/components/xhtml/page_191'
 import XHTMLPAGE_192 from '@/components/xhtml/page_192'
 import XHTMLPAGE_193 from '@/components/xhtml/page_193'
 import XHTMLPAGE_194 from '@/components/xhtml/page_194'
 import XHTMLPAGE_195 from '@/components/xhtml/page_195'
 import XHTMLPAGE_196 from '@/components/xhtml/page_196'
 import XHTMLPAGE_197 from '@/components/xhtml/page_197'
 import XHTMLPAGE_198 from '@/components/xhtml/page_198'
 import XHTMLPAGE_199 from '@/components/xhtml/page_199'
 import XHTMLPAGE_200 from '@/components/xhtml/page_200'
 import XHTMLPAGE_202 from '@/components/xhtml/page_202'
 import XHTMLPAGE_203 from '@/components/xhtml/page_203'
 import XHTMLPAGE_204 from '@/components/xhtml/page_204'
 import XHTMLPAGE_205 from '@/components/xhtml/page_205'
 import XHTMLPAGE_206 from '@/components/xhtml/page_206'
 import XHTMLPAGE_208 from '@/components/xhtml/page_208'
 import XHTMLPAGE_209 from '@/components/xhtml/page_209'
 import XHTMLPAGE_210 from '@/components/xhtml/page_210'
 import XHTMLPAGE_211 from '@/components/xhtml/page_211'
 import XHTMLPAGE_212 from '@/components/xhtml/page_212'
 import XHTMLPAGE_214 from '@/components/xhtml/page_214'
 import XHTMLPAGE_216 from '@/components/xhtml/page_216'
 import XHTMLPAGE_218 from '@/components/xhtml/page_218'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/preface",
 			"name" : "xhtml/preface",
 			"component" : XHTMLPREFACE
 		},
 		{
 			"path" : "/xhtml/ack",
 			"name" : "xhtml/ack",
 			"component" : XHTMLACK
 		},
 		{
 			"path" : "/xhtml/halftitle1",
 			"name" : "xhtml/halftitle1",
 			"component" : XHTMLHALFTITLE1
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js